import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import ObjectInfo from 'assets/templates/objectInfo/ObjectInfo';
import Sidebar from 'assets/templates/sidebar/Sidebar';
import { isValidPhoneNumber } from 'assets/utils/parsersAndValidation/Validators';
import { pick } from 'lodash';
import PurchaseState from 'models/enums/PurchaseState';
import { useContractProvider } from '../Contract.Hooks';

export default function ContractInfo() {
  const { selected, pageRouter } = useContractProvider();
  const { lang } = getLocales();

  return !selected ? null : (
    <Sidebar
      onClose={() => pageRouter.updateParams({})}
      icon={<Icon class="if-database" />}
      title={selected?.appNumber}
      subtitle={selected?.vehicle?.vin}
      content={
        <>
          <ObjectInfo
            object={pick(
              selected.client,
              'firstName',
              'lastName',
              'email',
              'phone',
              'streetAddress',
              'city',
              'provinceCode',
              'postalCode',
              'taxExempt'
            )}
            objectName={lang.client}
          />
          <ObjectInfo
            object={pick(
              {
                ...selected.vehicle,
                purchaseState:
                  selected.vehicle?.purchaseState === PurchaseState.USED
                    ? PurchaseState.PRE_OWNED
                    : selected.vehicle?.purchaseState,
              },
              'vin',
              'year',
              'makeCode',
              'model',
              'bodyType',
              'engineType',
              'fuelType',
              'posOdometerReading',
              'stockNumber',
              'purchasePrice',
              'purchaseState',
              'purchaseType',
              'inServiceDate',
              'mfgWholeVehicleWarrantyMonths',
              'mfgWholeVehicleWarrantyKm',
              'mfgPowertrainWarrantyMonths',
              'mfgPowertrainWarrantyKm',
              'isNew'
            )}
            objectName={lang.vehicle}
          />
          <ObjectInfo
            object={pick(
              {
                ...selected.dealer,
                primaryPhoneNumber: isValidPhoneNumber(selected.dealer.primaryPhoneNumber)
                  ? selected.dealer.primaryPhoneNumber
                  : selected.dealer.primaryPhoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
              },
              'name',
              'primaryPhoneNumber',
              'primaryEmailAddress',
              'streetAddress',
              'city',
              'provinceCode',
              'countryCode',
              'postalCode'
            )}
            objectName={lang.dealer}
          />
        </>
      }
    />
  );
}
